import * as React from 'react';

import './CalloutBarStyle.less';

export interface ICalloutBarProps {
  onClick: () => void;
  text: string;
}

export default class CalloutBar extends React.PureComponent<ICalloutBarProps> {
  public render() {
    const { onClick, text } = this.props;

    return (
      <div className="resale-closing-dashboard-callout-bar">
        <span className="callout-bar-callout" onClick={onClick}>
          {text}
        </span>
      </div>
    );
  }
}
